import React, { useEffect, useState } from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";
import moduleStyle from "./ReviewSelectionModal.module.css";
import { useReviewSelectionModal } from "./utils/useReviewSelectionModal";
import { ReviewSelectionList } from "./modules/ReviewSelectionList/ReviewSelectionList";
import { usePayment } from "features/AffiliateMarketing/utils/usePayment";
import { getSessionStorageItem } from "utils/getterAndSetters";
import { RUPEE_SYMBOL } from "features/Common/modules/Currency/constants/Currency.constants";
import { roundOff } from "utils/Utils";
import ExlyLoader from "ui/modules/ExlyLoader";
import { is_empty } from "utils/validations";
import { SESSION_STORAGE_KEYS } from "features/Common/modules/Storage/modules/SessionStorage/constants/SessionStorage.constant";
import { getUserCurrencySymbol } from "utils/AuthUtil";
import { walletKeys } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";
import { roundOffIfDecimal } from "features/Common/modules/DataTypes/utils/numbers";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";

export const ReviewSelectionModal = () => {
  const { showPayoutListModal, toggleShowPayoutListModal, payout, processing } =
    useReviewSelectionModal();
  const { initiatePayment } = usePayment();
  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const isPayViaWallet = useWalletStore((state) => state.isPayViaWallet);
  const setIsPayViaWallet = useWalletStore((state) => state.setIsPayViaWallet);
  const { walletBalance, walletDeductionCalc, refreshWalletBalance } =
    useWallets({
      isFetchWalletBalanceEnabled: true,
    });
  const [buttonLabel, setButtonLabel] = useState("...");

  useEffect(() => {
    refreshWalletBalance();
  }, []);

  useEffect(() => {
    setButtonLabel(
      processing ? (
        "..."
      ) : (
        <div className={`d-flex align-items-center`}>
          <div>{`Pay ${RUPEE_SYMBOL}${roundOff(
            payout?.final_gateway_amount,
            2
          )}`}</div>
        </div>
      )
    );
  }, [processing]);

  const handleWalletSelectionChange = (e) => {
    let isChecked = e?.target?.checked;
    setIsPayViaWallet(isChecked);
    let walletDeductionInfo = walletDeductionCalc({
      totalAmount: payout?.final_gateway_amount,
    });
    let buttonName = "";
    if (isChecked) {
      if (is_empty(parseInt(walletDeductionInfo?.totalAmount))) {
        buttonName = `Confirm Wallet Debit of ${RUPEE_SYMBOL}${walletDeductionInfo.usedFromWallet}`;
      } else {
        buttonName = `Pay ${RUPEE_SYMBOL}${walletDeductionInfo.totalAmount}`;
      }
    } else {
      buttonName = `Pay ${RUPEE_SYMBOL}${roundOffIfDecimal(
        isChecked
          ? walletDeductionInfo?.totalAmount
          : payout?.final_gateway_amount,
        2
      )}`;
    }
    setButtonLabel(
      <div className={`d-flex align-items-center`}>
        <div>{buttonName}</div>
      </div>
    );
  };

  return (
    <ExlyModal
      open={showPayoutListModal}
      onClose={() => toggleShowPayoutListModal()}
      modal_props={{
        modalPaperClassName: moduleStyle.reviewSelectionContainer,
      }}
      title={"Payout Commissions"}
      primaryBtnText={buttonLabel}
      showSecondaryBtn={false}
      primaryBtnFullWidth
      primaryBtnProps={{ disabled: payout?.disable_pay_button }}
      onPrimaryBtnClick={() => {
        initiatePayment({
          requestId: getSessionStorageItem(
            SESSION_STORAGE_KEYS.AFFILIATE_PAYOUT_REQUEST_ID
          ),
          closeModal: toggleShowPayoutListModal,
        });
      }}
      className="!tw-p-0"
    >
      <div className="tw-mt-2">
        {processing && is_empty(payout) ? (
          <ExlyLoader />
        ) : (
          <>
            <div className="tw-p-[0px_24px]">
              <ReviewSelectionList />
            </div>
            {isWalletActive && (
              <>
                <div className="tw-flex tw-items-center tw-justify-between tw-leading-[14.32px] tw-py-[10px] tw-px-[24px] tw-text-black tw-w-full tw-bg-[#F2F0FF] tw-border-[#DFDCFA] tw-border-x tw-border-y-0 tw-border-solid">
                  <span className="tw-text-[14px] tw-flex tw-items-start tw-gap-[10px]">
                    <Checkbox
                      size="large"
                      wrapperClassName="!tw-border-[1.5px] !tw-border-solid !tw-border-[#493AB1]"
                      disabled={
                        walletBalance?.[walletKeys.walletBalance] ? false : true
                      }
                      checked={isPayViaWallet}
                      onChange={handleWalletSelectionChange}
                    />
                    <div className="tw-flex tw-gap-[10px]">
                      <span className="tw-font-medium tw-text-[17px]">
                        Use Exly Wallet balance
                      </span>
                      <span className="!tw-font-normal tw-text-[#27252299] tw-text-[15px]">
                        {"("}Current balance:{" "}
                        {`${getUserCurrencySymbol()}${
                          walletBalance?.[walletKeys.walletBalance]
                        }`}
                        {")"}
                      </span>
                    </div>
                  </span>
                  {/* uncomment when top up will be enabled */}
                  {/* {payout?.final_gateway_amount >
                  walletBalance?.[walletKeys.walletBalance] ? (
                    <Button
                      color="link"
                      size="small"
                      className="!tw-bg-transparent !tw-h-[14px] !tw-underline"
                      onClick={handleTopUpWalletClick}
                    >
                      <span className="!tw-text-[14px] tw-text-[#493AB1]">
                        Top-up wallet
                      </span>
                    </Button>
                  ) : null} */}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </ExlyModal>
  );
};
